import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { installmentActions } from '../ActionTypes';


export const fetchInstallment = () => async (dispatch) => {
  try {
    dispatch({
      type: installmentActions.INSTALLMENT_FETCH_START
    });

    const resData = await Service.GET({
      name: 'installment',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: installmentActions.INSTALLMENT_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: installmentActions.INSTALLMENT_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};
export const saveInstallment = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData
    };
    dispatch({
      type: installmentActions.INSTALLMENT_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'installment',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: installmentActions.INSTALLMENT_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/installment'; }, 1000);
  } catch (error) {
    dispatch({
      type: installmentActions.INSTALLMENT_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};

export const editInstallment = (installmentId) => async (dispatch, getState) => {
  try {
    const { installmentList } = getState().installment;
    const data = installmentList.find((item) => item.Id === installmentId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: installmentActions.INSTALLMENT_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const resetForm = () => (dispatch) => dispatch({ type: installmentActions.INSTALLMENT_RESET_FORM });

export const deleteInstallment = (Id) => async (dispatch) => Service.DELETE({
  name: 'installment',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchInstallment());
    return true;
  }
  throw new Error(res.message);
});
